import React from 'react';
import { t } from '../../lib/i18n';
import { Badge } from '../ui/badge';
import { Shield, Target, AlertTriangle, Brain } from 'lucide-react';

export function CounterpartyProfile({ profile, lang = 'pl' }) {
  if (!profile) {
    return (
      <div className="text-center py-8 text-muted-foreground text-sm">
        {lang === 'pl' ? 'Brak profilu - rozpocznij rozmow\u0119' : 'No profile - start conversation'}
      </div>
    );
  }

  const trustPercent = Math.round((profile.trust_level || 0) * 100);
  const trustColor = trustPercent >= 60 ? 'text-emerald-400' : trustPercent >= 35 ? 'text-amber-400' : 'text-red-400';

  return (
    <div className="space-y-4" data-testid="counterparty-profile-panel">
      {/* Trust Level */}
      <div className="text-center py-3 rounded-xl bg-muted/50 border border-border">
        <div className={`text-2xl font-semibold tabular-nums ${trustColor}`} style={{ fontFamily: 'Space Grotesk' }}>
          {trustPercent}%
        </div>
        <div className="text-xs text-muted-foreground mt-1">{t('trustLevel', lang)}</div>
      </div>

      {/* Style & Knowledge */}
      <div className="grid grid-cols-2 gap-2">
        <div className="p-2.5 rounded-lg bg-muted/30 border border-border">
          <div className="flex items-center gap-1.5 mb-1">
            <Brain className="w-3 h-3 text-primary" />
            <span className="text-xs text-muted-foreground">{t('negotiationStyle', lang)}</span>
          </div>
          <span className="text-xs font-medium capitalize">{profile.negotiation_style || '-'}</span>
        </div>
        <div className="p-2.5 rounded-lg bg-muted/30 border border-border">
          <div className="flex items-center gap-1.5 mb-1">
            <Shield className="w-3 h-3 text-primary" />
            <span className="text-xs text-muted-foreground">{t('knowledgeLevel', lang)}</span>
          </div>
          <span className="text-xs font-medium capitalize">{profile.knowledge_level || '-'}</span>
        </div>
      </div>

      {/* Strategy */}
      <div className="p-2.5 rounded-lg bg-primary/5 border border-primary/20">
        <div className="flex items-center gap-1.5 mb-1">
          <Target className="w-3 h-3 text-primary" />
          <span className="text-xs text-muted-foreground">{t('recommendedStrategy', lang)}</span>
        </div>
        <span className="text-xs font-medium text-primary capitalize">
          {(profile.recommended_strategy || '-').replace(/_/g, ' ')}
        </span>
      </div>

      {/* Motivations */}
      {profile.motivations && profile.motivations.length > 0 && (
        <div>
          <div className="text-xs text-muted-foreground mb-1.5">{t('motivations', lang)}</div>
          <div className="flex flex-wrap gap-1">
            {profile.motivations.map((m, i) => (
              <Badge key={i} variant="secondary" className="text-xs py-0">{m}</Badge>
            ))}
          </div>
        </div>
      )}

      {/* Weak Points */}
      {profile.weak_points && profile.weak_points.length > 0 && (
        <div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground mb-1.5">
            <AlertTriangle className="w-3 h-3" />
            {t('weakPoints', lang)}
          </div>
          <div className="flex flex-wrap gap-1">
            {profile.weak_points.map((w, i) => (
              <Badge key={i} variant="outline" className="text-xs py-0 border-amber-400/30 text-amber-400">{w}</Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
